import { useCallback, useEffect, useState } from 'react';
import API from '../api';
import { TabGrupos } from './Clientes';

const ROLES = [
  ['admin', 'Administrador'],
  ['administrativa', 'Administrativa'],
  ['tecnico', 'Técnico'],
  ['recursos_humanos', 'Recursos humanos'],
  ['user', 'Usuario básico'],
];

const emptyForm = { nombre: '', email: '', password: '', rol: 'recursos_humanos', activo: true };
const MESES_REGISTROS = ['ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE'];

function descargarContenido(contenido, nombre, tipo = 'text/csv;charset=utf-8;') {
  const url = URL.createObjectURL(new Blob([contenido], { type: tipo }));
  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = nombre;
  document.body.appendChild(enlace);
  enlace.click();
  document.body.removeChild(enlace);
  URL.revokeObjectURL(url);
}

function RegistrosDatos({ card, input, setMsg }) {
  const hoy = new Date();
  const [anios, setAnios] = useState([String(hoy.getFullYear())]);
  const [filtros, setFiltros] = useState({
    anio: String(hoy.getFullYear()),
    mes: MESES_REGISTROS[hoy.getMonth()],
    estado: '',
    cliente: '',
  });
  const [archivo, setArchivo] = useState(null);
  const [reemplazar, setReemplazar] = useState(false);
  const [clave, setClave] = useState({ actual: '', nueva: '', confirma: '' });
  const [procesando, setProcesando] = useState('');

  useEffect(() => {
    API.get('/registros-anios')
      .then(r => setAnios(Array.isArray(r.data) && r.data.length ? r.data.map(String) : [String(new Date().getFullYear())]))
      .catch(() => {});
  }, []);

  async function descargarBlob(endpoint, nombre, params = {}) {
    const r = await API.get(endpoint, { params, responseType: 'blob' });
    const url = URL.createObjectURL(new Blob([r.data]));
    const enlace = document.createElement('a');
    enlace.href = url;
    enlace.download = nombre;
    document.body.appendChild(enlace);
    enlace.click();
    document.body.removeChild(enlace);
    URL.revokeObjectURL(url);
  }

  async function exportarCSV() {
    setProcesando('csv');
    setMsg('Preparando exportación de registros...');
    try {
      const params = {};
      if (filtros.anio && filtros.mes) params.mes = `${filtros.mes} ${filtros.anio}`;
      else if (filtros.anio) params.anio = filtros.anio;
      if (filtros.estado) params.estado = filtros.estado;
      if (filtros.cliente.trim()) params.cliente = filtros.cliente.trim();
      const r = await API.get('/registros', { params });
      const registros = Array.isArray(r.data) ? r.data : [];
      const headers = ['Fecha','Mes','Cliente','Servicio','Tipo','Valor','Costo','Comisión %','Utilidad','IVA','Factura','Estado','Notas'];
      const rows = registros.map(item => [
        item.fecha?.slice(0, 10), item.mes, item.cliente_organizado || item.cliente,
        item.servicio_organizado || item.servicio, item.tipo, item.valor, item.costo,
        item.comision_pct || 0, item.utilidad, item.valor_iva, item.factura, item.estado, item.notas || '',
      ]);
      const csv = [headers, ...rows]
        .map(row => row.map(valor => `"${String(valor ?? '').replace(/"/g, '""')}"`).join(','))
        .join('\n');
      const periodo = filtros.anio && filtros.mes ? `${filtros.mes}_${filtros.anio}` : filtros.anio || 'historico';
      descargarContenido('\uFEFF' + csv, `registros_${periodo}_${new Date().toISOString().slice(0, 10)}.csv`);
      setMsg(`CSV descargado: ${registros.length} registros`);
    } catch (err) {
      setMsg(err?.response?.data?.error || 'No se pudo exportar el CSV');
    } finally {
      setProcesando('');
    }
  }

  async function descargarPlantilla() {
    setProcesando('plantilla');
    try {
      const anio = filtros.anio || String(hoy.getFullYear());
      const mes = filtros.mes || MESES_REGISTROS[hoy.getMonth()];
      await descargarBlob('/ajustes/registros-plantilla', `plantilla_registros_${mes}_${anio}.csv`, { anio, mes });
      setMsg('Plantilla descargada');
    } catch (err) {
      setMsg(err?.response?.data?.error || 'No se pudo descargar la plantilla');
    } finally {
      setProcesando('');
    }
  }

  async function importarPlantilla() {
    if (!archivo) { setMsg('Selecciona el archivo CSV diligenciado'); return; }
    setProcesando('importar');
    try {
      const csv = await archivo.text();
      const r = await API.post('/ajustes/importar-registros', { csv, reemplazar });
      setArchivo(null);
      setMsg(`Importados ${r.data.insertados} registros (${(r.data.meses || []).join(', ')})`);
    } catch (err) {
      setMsg(err?.response?.data?.error || 'No se pudo importar la plantilla');
    } finally {
      setProcesando('');
    }
  }

  async function cambiarClave() {
    if (!clave.actual || !clave.nueva) { setMsg('Completa la clave actual y la nueva'); return; }
    if (clave.nueva !== clave.confirma) { setMsg('La confirmación de clave no coincide'); return; }
    setProcesando('clave');
    try {
      await API.post('/ajustes/cambiar-clave', { actual: clave.actual, nueva: clave.nueva });
      setClave({ actual: '', nueva: '', confirma: '' });
      setMsg('Clave actualizada correctamente');
    } catch (err) {
      setMsg(err?.response?.data?.error || 'No se pudo cambiar la clave');
    } finally {
      setProcesando('');
    }
  }

  return (
    <div style={{ display: 'grid', gap: 12, maxWidth: 1040 }}>
      <section style={{ ...card, padding: 18 }}>
        <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1 }}>Exportar registros</div>
        <h2 style={{ color: '#08293f', fontSize: 17, margin: '7px 0' }}>Archivo CSV</h2>
        <p style={{ color: '#5a7185', fontSize: 12, lineHeight: 1.6, margin: '0 0 14px' }}>Descarga los registros aplicando periodo, estado y cliente. La exportación respeta los nombres organizados.</p>
        <div style={{ display: 'grid', gridTemplateColumns: '130px 180px 160px minmax(190px, 1fr) auto', gap: 8, alignItems: 'end' }} className="config-registros-filtros">
          <label style={{ color: '#6b8295', fontSize: 11, fontWeight: 700 }}>Año<select value={filtros.anio} onChange={e => setFiltros(f => ({ ...f, anio: e.target.value, mes: e.target.value ? f.mes : '' }))} style={{ ...input, marginTop: 4 }}><option value="">Histórico</option>{anios.map(a => <option key={a} value={a}>{a}</option>)}</select></label>
          <label style={{ color: '#6b8295', fontSize: 11, fontWeight: 700 }}>Mes<select value={filtros.mes} disabled={!filtros.anio} onChange={e => setFiltros(f => ({ ...f, mes: e.target.value }))} style={{ ...input, marginTop: 4 }}><option value="">Todo el año</option>{MESES_REGISTROS.map(m => <option key={m} value={m}>{m}</option>)}</select></label>
          <label style={{ color: '#6b8295', fontSize: 11, fontWeight: 700 }}>Estado<select value={filtros.estado} onChange={e => setFiltros(f => ({ ...f, estado: e.target.value }))} style={{ ...input, marginTop: 4 }}><option value="">Todos</option>{['PAGADO','PENDIENTE','FACTURADO','RETEIVA'].map(e => <option key={e} value={e}>{e}</option>)}</select></label>
          <label style={{ color: '#6b8295', fontSize: 11, fontWeight: 700 }}>Cliente<input value={filtros.cliente} onChange={e => setFiltros(f => ({ ...f, cliente: e.target.value }))} placeholder="Todos los clientes" style={{ ...input, marginTop: 4 }} /></label>
          <button onClick={exportarCSV} disabled={!!procesando} style={{ border: 'none', background: '#08293f', color: '#fff', padding: '10px 16px', fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>{procesando === 'csv' ? 'Generando...' : 'Descargar CSV'}</button>
        </div>
      </section>

      <section style={{ ...card, padding: 18 }}>
        <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1 }}>Importar registros</div>
        <h2 style={{ color: '#08293f', fontSize: 17, margin: '7px 0' }}>Plantilla para meses anteriores</h2>
        <p style={{ color: '#5a7185', fontSize: 12, lineHeight: 1.6, margin: '0 0 14px' }}>Descarga la plantilla del año y mes seleccionados arriba, diligénciala y vuelve a cargar el CSV.</p>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <button onClick={descargarPlantilla} disabled={!!procesando} style={{ border: '1px solid var(--app-border)', background: 'var(--app-surface)', color: 'var(--app-heading)', padding: '9px 13px', fontWeight: 700, cursor: 'pointer' }}>{procesando === 'plantilla' ? 'Preparando...' : 'Bajar plantilla'}</button>
          <input type="file" accept=".csv,text/csv" onChange={e => setArchivo(e.target.files?.[0] || null)} />
          <label style={{ display: 'flex', gap: 6, alignItems: 'center', color: '#5a7185', fontSize: 12 }}><input type="checkbox" checked={reemplazar} onChange={e => setReemplazar(e.target.checked)} />Reemplazar el mes importado</label>
          <button onClick={importarPlantilla} disabled={!!procesando || !archivo} style={{ border: 'none', background: '#00b8e3', color: '#08293f', padding: '9px 13px', fontWeight: 700, cursor: 'pointer', opacity: archivo ? 1 : 0.55 }}>{procesando === 'importar' ? 'Importando...' : 'Subir plantilla'}</button>
        </div>
      </section>

      <section style={{ ...card, padding: 18 }}>
        <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1 }}>Seguridad de la cuenta</div>
        <h2 style={{ color: '#08293f', fontSize: 17, margin: '7px 0 14px' }}>Cambiar mi clave</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(180px, 1fr)) auto', gap: 8, alignItems: 'end' }} className="config-registros-clave">
          <label style={{ color: '#6b8295', fontSize: 11, fontWeight: 700 }}>Clave actual<input type="password" value={clave.actual} onChange={e => setClave(c => ({ ...c, actual: e.target.value }))} style={{ ...input, marginTop: 4 }} /></label>
          <label style={{ color: '#6b8295', fontSize: 11, fontWeight: 700 }}>Nueva clave<input type="password" value={clave.nueva} onChange={e => setClave(c => ({ ...c, nueva: e.target.value }))} style={{ ...input, marginTop: 4 }} /></label>
          <label style={{ color: '#6b8295', fontSize: 11, fontWeight: 700 }}>Confirmar clave<input type="password" value={clave.confirma} onChange={e => setClave(c => ({ ...c, confirma: e.target.value }))} style={{ ...input, marginTop: 4 }} /></label>
          <button onClick={cambiarClave} disabled={!!procesando} style={{ border: 'none', background: '#08293f', color: '#fff', padding: '10px 16px', fontWeight: 700, cursor: 'pointer' }}>{procesando === 'clave' ? 'Guardando...' : 'Guardar clave'}</button>
        </div>
      </section>
      <style>{`@media (max-width: 900px) { .config-registros-filtros, .config-registros-clave { grid-template-columns: 1fr 1fr !important; } } @media (max-width: 560px) { .config-registros-filtros, .config-registros-clave { grid-template-columns: 1fr !important; } }`}</style>
    </div>
  );
}

const PANEL_BASE_ITEMS = [
  { id: 'normal', icon: 'AD', label: 'Software completo', desc: 'Entrar al sistema administrativo', group: 'Principal', visible: true, order: 10 },
  { id: 'dashboard', icon: 'DB', label: 'Dashboard', desc: 'Indicadores generales', group: 'Principal', visible: true, order: 20 },
  { id: 'registros', icon: 'RG', label: 'Registros', desc: 'Ingresos, servicios y cartera', group: 'Principal', visible: true, order: 30 },
  { id: 'clientes', icon: 'CL', label: 'Clientes', desc: 'Fichas, cotizaciones e inventarios', group: 'Principal', visible: true, order: 40 },
  { id: 'gastos', icon: 'GT', label: 'Gastos', desc: 'Fijos y variables', group: 'Principal', visible: true, order: 50 },
  { id: 'iva', icon: 'IV', label: 'IVA', desc: 'IVA generado y descontable', group: 'Principal', visible: true, order: 60 },
  { id: 'rentabilidad', icon: 'RN', label: 'Rentabilidad', desc: 'Clientes, servicios y márgenes', group: 'Principal', visible: true, order: 70 },
  { id: 'tecnicoEmpresas', icon: 'EM', label: 'Empresas', desc: 'Empresas seleccionadas e inventario', group: 'Empresas', visible: true, order: 80 },
  { id: 'tecnico', icon: 'TC', label: 'Técnico', desc: 'Registro, empresas y agenda', group: 'Empresas', visible: true, order: 90 },
  { id: 'ss', icon: 'SS', label: 'Seguridad Social', desc: 'Liquidación y pagos PILA', group: 'Personal', visible: true, order: 100 },
  { id: 'nomina', icon: 'NO', label: 'Nómina', desc: 'Liquidación, comprobantes e historial', group: 'Personal', visible: true, order: 110 },
  { id: 'credito', icon: 'CV', label: 'Crédito vehículo', desc: 'Cuotas, abonos y saldo', group: 'Personal', visible: true, order: 120 },
  { id: 'inversiones', icon: 'IN', label: 'Inversiones', desc: 'Trading, CDT y Bitcoin', group: 'Inversiones', visible: true, order: 130 },
  { id: 'academia', icon: 'AC', label: 'Academia', desc: 'Alumnos y pagos', group: 'Otros', visible: true, order: 150 },
  { id: 'configuracion', icon: 'CF', label: 'Configuración', desc: 'Usuarios, permisos y respaldos', group: 'Otros', visible: true, order: 160 },
];

function PanelPrincipalEditor({ card, input, setMsg }) {
  const [items, setItems] = useState(PANEL_BASE_ITEMS);
  const [guardando, setGuardando] = useState(false);
  const [nuevoGrupo, setNuevoGrupo] = useState('');
  const [gruposExtra, setGruposExtra] = useState([]);
  const [arrastrando, setArrastrando] = useState(null);
  const [grupoPreview, setGrupoPreview] = useState('');

  const cargarPanel = useCallback(async () => {
    try {
      const r = await API.get('/configuracion/panel-principal');
      setItems(Array.isArray(r.data?.items) ? r.data.items : PANEL_BASE_ITEMS);
    } catch (_) {
      setMsg('No se pudo cargar la configuración del panel');
    }
  }, [setMsg]);

  useEffect(() => { cargarPanel(); }, [cargarPanel]);

  function updateItem(id, changes) {
    setItems(prev => prev.map(item => item.id === id ? { ...item, ...changes } : item));
  }

  function moveItem(id, dir, scope = null) {
    setItems(prev => {
      const ordered = [...prev].sort((a, b) => Number(a.order || 0) - Number(b.order || 0));
      const scopedIds = ordered
        .filter(item => !scope || (item.group || 'Principal') === scope)
        .map(item => item.id);
      const localIdx = scopedIds.indexOf(id);
      const swapId = scopedIds[localIdx + dir];
      if (localIdx < 0 || !swapId) return prev;
      const idx = ordered.findIndex(item => item.id === id);
      const nextIdx = ordered.findIndex(item => item.id === swapId);
      const tmpOrder = ordered[idx].order;
      ordered[idx] = { ...ordered[idx], order: ordered[nextIdx].order };
      ordered[nextIdx] = { ...ordered[nextIdx], order: tmpOrder };
      return ordered;
    });
  }

  function moverAGrupo(id, group) {
    updateItem(id, { group, visible: true });
  }

  function moverDesdeVistaPrevia(id, group, beforeId = null) {
    setItems(prev => {
      const orderedPrev = [...prev].sort((a, b) => Number(a.order || 0) - Number(b.order || 0));
      const isGroup = String(id).startsWith('grupo:');
      const movingGroup = isGroup ? String(id).slice(6) : null;
      const moving = isGroup ? null : orderedPrev.find(item => item.id === id);
      const movingItems = isGroup ? orderedPrev.filter(item => (item.group || 'Principal') === movingGroup) : (moving ? [moving] : []);
      if (!movingItems.length) return prev;
      const targetGroup = group || 'Principal';
      const movingIds = new Set(movingItems.map(item => item.id));
      const without = orderedPrev.filter(item => !movingIds.has(item.id));
      const moved = movingItems.map(item => ({ ...item, group: targetGroup, visible: true }));
      const targetBeforeId = String(beforeId || '').startsWith('grupo:')
        ? without.find(item => (item.group || 'Principal') === String(beforeId).slice(6))?.id
        : beforeId;
      let insertAt = targetBeforeId ? without.findIndex(item => item.id === targetBeforeId) : -1;
      if (insertAt < 0) {
        const lastInGroup = without
          .map((item, index) => ({ item, index }))
          .filter(x => x.item.visible !== false && (x.item.group || 'Principal') === targetGroup)
          .pop();
        insertAt = lastInGroup ? lastInGroup.index + 1 : without.length;
      }
      without.splice(insertAt, 0, ...moved);
      return without.map((item, index) => ({ ...item, order: (index + 1) * 10 }));
    });
  }

  function dragProps(id) {
    return {
      draggable: true,
      onDragStart: e => {
        setArrastrando(id);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', id);
      },
      onDragEnd: () => setArrastrando(null),
    };
  }

  function dropProps(group, beforeId = null) {
    return {
      onDragOver: e => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
      },
      onDrop: e => {
        e.preventDefault();
        const id = e.dataTransfer.getData('text/plain') || arrastrando;
        if (id) moverDesdeVistaPrevia(id, group, beforeId);
        setArrastrando(null);
      },
    };
  }

  function crearGrupo() {
    const nombre = nuevoGrupo.trim();
    if (!nombre) return;
    setGruposExtra(prev => prev.includes(nombre) ? prev : [...prev, nombre]);
    setNuevoGrupo('');
  }

  function resetBase() {
    setItems(PANEL_BASE_ITEMS);
  }

  async function guardar() {
    setGuardando(true);
    setMsg('');
    try {
      const normalized = [...items].sort((a, b) => Number(a.order || 0) - Number(b.order || 0)).map((item, index) => ({ ...item, order: (index + 1) * 10 }));
      const r = await API.put('/configuracion/panel-principal', { rol: 'admin', items: normalized });
      setItems(Array.isArray(r.data?.items) ? r.data.items : normalized);
      setMsg('Panel principal guardado');
    } catch (err) {
      setMsg(err?.response?.data?.error || 'No se pudo guardar el panel');
    } finally {
      setGuardando(false);
    }
  }

  const ordered = [...items].sort((a, b) => Number(a.order || 0) - Number(b.order || 0));
  const groups = [...new Set([...ordered.map(item => item.group || 'Principal'), ...gruposExtra, nuevoGrupo.trim()].filter(Boolean))];
  const gruposInternos = groups.filter(g => g !== 'Principal');
  const grupoPreviewActivo = gruposInternos.includes(grupoPreview) ? grupoPreview : gruposInternos[0];
  const destinos = ['Principal', ...gruposInternos, ...(nuevoGrupo.trim() && !groups.includes(nuevoGrupo.trim()) ? [nuevoGrupo.trim()] : [])];
  const inicio = ordered.filter(item => item.visible !== false && (item.group || 'Principal') === 'Principal');
  const ocultos = ordered.filter(item => item.visible === false);
  const panelesInicio = [
    ...inicio.map(item => ({ kind: 'item', key: item.id, order: Number(item.order || 0), item })),
    ...gruposInternos.map(group => {
      const groupItems = ordered.filter(item => item.visible !== false && (item.group || 'Principal') === group);
      if (!groupItems.length) return null;
      return { kind: 'group', key: `grupo:${group}`, group, items: groupItems, order: Math.min(...groupItems.map(item => Number(item.order || 0))) };
    }).filter(Boolean),
  ].sort((a, b) => a.order - b.order);

  const miniCard = (item, scope) => (
    <div key={item.id} style={{ background: item.visible === false ? '#f8fafc' : '#fff', border: '1px solid #e2eaf0', padding: 10, display: 'grid', gap: 8 }}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input value={item.icon || ''} maxLength={4} onChange={e => updateItem(item.id, { icon: e.target.value.toUpperCase() })} style={{ ...input, width: 44, textAlign: 'center', fontWeight: 900, padding: '8px 5px' }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <input value={item.label || ''} onChange={e => updateItem(item.id, { label: e.target.value })} style={{ ...input, fontWeight: 800, marginBottom: 5 }} />
          <input value={item.desc || ''} onChange={e => updateItem(item.id, { desc: e.target.value })} style={{ ...input, fontSize: 11, color: '#5a7185' }} />
        </div>
      </div>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
        <select value={item.group || 'Principal'} onChange={e => moverAGrupo(item.id, e.target.value)} style={{ ...input, width: 160, padding: '7px 8px', fontSize: 11 }}>
          {destinos.map(g => <option key={g} value={g}>{g === 'Principal' ? 'Ver al entrar' : g}</option>)}
        </select>
        {nuevoGrupo.trim() && <button type="button" onClick={() => moverAGrupo(item.id, nuevoGrupo.trim())} style={{ border: '1px solid #d8e5ec', background: '#fff', color: '#08293f', padding: '7px 9px', fontSize: 11, fontWeight: 800, cursor: 'pointer' }}>Mover a {nuevoGrupo.trim()}</button>}
        <button type="button" onClick={() => updateItem(item.id, { visible: item.visible === false })} style={{ border: '1px solid #d8e5ec', background: item.visible === false ? '#00b8e3' : '#fff', color: item.visible === false ? '#fff' : '#08293f', padding: '7px 9px', fontSize: 11, fontWeight: 800, cursor: 'pointer' }}>{item.visible === false ? 'Mostrar' : 'Ocultar'}</button>
        {item.visible !== false && (
          <>
            <button type="button" onClick={() => moveItem(item.id, -1, scope)} style={{ border: '1px solid #d8e5ec', background: '#fff', color: '#08293f', padding: '7px 9px', cursor: 'pointer' }}>↑</button>
            <button type="button" onClick={() => moveItem(item.id, 1, scope)} style={{ border: '1px solid #d8e5ec', background: '#fff', color: '#08293f', padding: '7px 9px', cursor: 'pointer' }}>↓</button>
          </>
        )}
      </div>
    </div>
  );

  const previewCard = (label, icon, detail, options = {}) => (
    <div {...(options.dragId ? dragProps(options.dragId) : {})} {...(options.drop ? dropProps(options.drop.group, options.drop.beforeId) : {})} style={{ border: `1px solid ${options.active ? '#00b8e3' : 'rgba(0,184,227,0.22)'}`, background: options.active ? 'rgba(0,184,227,0.16)' : 'rgba(0,184,227,0.07)', padding: 12, textAlign: 'center', minHeight: 104, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: options.dragId ? 'grab' : 'default' }}>
      <div style={{ width: 34, height: 34, margin: '0 auto 8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#00b8e3', background: 'rgba(0,184,227,0.12)', fontSize: 11, fontWeight: 900 }}>{icon}</div>
      <div style={{ color: '#fff', fontSize: 12, fontWeight: 900, marginBottom: 4 }}>{label}</div>
      <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: 10 }}>{detail}</div>
    </div>
  );

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(360px, 1fr) 330px', gap: 14, alignItems: 'start' }}>
      <section style={{ ...card, padding: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'center', marginBottom: 12 }}>
          <div>
            <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1 }}>Panel principal</div>
            <div style={{ color: '#5a7185', fontSize: 12, marginTop: 4 }}>Organiza lo que ves al entrar y arma grupos como Personal o Empresas.</div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" onClick={resetBase} style={{ border: '1px solid #d8e5ec', background: '#fff', color: '#08293f', padding: '8px 12px', fontWeight: 800, cursor: 'pointer' }}>Restaurar base</button>
            <button type="button" disabled={guardando} onClick={guardar} style={{ border: 'none', background: '#00b8e3', color: '#fff', padding: '8px 12px', fontWeight: 800, cursor: 'pointer' }}>{guardando ? 'Guardando...' : 'Guardar panel'}</button>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(260px, 1fr) minmax(260px, 1fr)', gap: 12, alignItems: 'start' }}>
          <section style={{ border: '1px solid #d8e5ec', padding: 12, background: '#f8fbfd' }}>
            <div style={{ fontSize: 11, color: '#08293f', fontWeight: 900, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>Veo al entrar</div>
            <div style={{ color: '#5a7185', fontSize: 11, marginBottom: 10 }}>Estas tarjetas aparecen directamente en el panel principal.</div>
            <div style={{ display: 'grid', gap: 8 }}>{inicio.map(item => miniCard(item, 'Principal'))}</div>
            {!inicio.length && <div style={{ color: '#6b8295', fontSize: 12, padding: 18, textAlign: 'center' }}>No hay tarjetas directas.</div>}
          </section>

          <section style={{ display: 'grid', gap: 12 }}>
            <div style={{ border: '1px solid #d8e5ec', padding: 12, background: '#f8fbfd' }}>
              <div style={{ fontSize: 11, color: '#08293f', fontWeight: 900, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>Crear o usar grupo</div>
              <div style={{ display: 'flex', gap: 8 }}>
                <input value={nuevoGrupo} onChange={e => setNuevoGrupo(e.target.value)} placeholder="Ej: Personal" style={input} />
                <button type="button" onClick={crearGrupo} style={{ border: 'none', background: '#08293f', color: '#fff', padding: '9px 12px', fontWeight: 800, cursor: 'pointer' }}>Crear</button>
              </div>
            </div>
            {gruposInternos.map(group => {
              const groupItems = ordered.filter(item => item.visible !== false && (item.group || 'Principal') === group);
              return (
                <section key={group} style={{ border: '1px solid #d8e5ec', padding: 12, background: '#fff' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'center', marginBottom: 8 }}>
                    <div>
                      <div style={{ fontSize: 11, color: '#08293f', fontWeight: 900, textTransform: 'uppercase', letterSpacing: 1 }}>{group}</div>
                      <div style={{ color: '#5a7185', fontSize: 11 }}>{groupItems.length} opciones dentro</div>
                    </div>
                    <button type="button" onClick={() => setItems(prev => prev.map(item => (item.group || 'Principal') === group ? { ...item, group: 'Principal' } : item))} style={{ border: '1px solid #d8e5ec', background: '#fff', color: '#08293f', padding: '6px 9px', fontSize: 11, fontWeight: 800, cursor: 'pointer' }}>Enviar a inicio</button>
                  </div>
                  <div style={{ display: 'grid', gap: 8 }}>{groupItems.map(item => miniCard(item, group))}</div>
                </section>
              );
            })}
          </section>
        </div>

        {ocultos.length > 0 && (
          <section style={{ border: '1px solid #d8e5ec', padding: 12, background: '#f8fafc', marginTop: 12 }}>
            <div style={{ fontSize: 11, color: '#08293f', fontWeight: 900, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>Ocultos</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 8 }}>
              {ocultos.map(item => miniCard(item, item.group || 'Principal'))}
            </div>
          </section>
        )}
      </section>

      <section style={{ ...card, padding: 16 }}>
        <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>Vista previa</div>
        <div style={{ background: '#08293f', padding: 14, display: 'grid', gap: 16 }}>
          <div style={{ color: 'rgba(255,255,255,0.48)', fontSize: 10, fontWeight: 900, letterSpacing: 1.2, textTransform: 'uppercase' }}>Al entrar</div>
          <div {...dropProps('Principal')} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, minHeight: 112, border: arrastrando ? '1px dashed rgba(0,184,227,0.35)' : '1px dashed transparent', padding: arrastrando ? 6 : 0 }}>
            {panelesInicio.map(panel => {
              if (panel.kind === 'item') {
                return previewCard(panel.item.label, panel.item.icon, 'Directo', {
                  dragId: panel.item.id,
                  drop: { group: 'Principal', beforeId: panel.item.id },
                  active: arrastrando === panel.item.id,
                });
              }
              return previewCard(panel.group, panel.group.slice(0, 2).toUpperCase(), `${panel.items.length} opciones`, {
                dragId: `grupo:${panel.group}`,
                drop: { group: arrastrando && !String(arrastrando).startsWith('grupo:') ? panel.group : 'Principal', beforeId: arrastrando && String(arrastrando).startsWith('grupo:') ? `grupo:${panel.group}` : null },
                active: arrastrando === `grupo:${panel.group}`,
              });
            })}
          </div>
          {gruposInternos.length > 0 && (
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {gruposInternos.map(group => (
                <button key={group} type="button" onClick={() => setGrupoPreview(group)} style={{ border: '1px solid rgba(0,184,227,0.25)', background: group === grupoPreviewActivo ? 'rgba(0,184,227,0.18)' : 'rgba(0,184,227,0.06)', color: group === grupoPreviewActivo ? '#00b8e3' : 'rgba(255,255,255,0.65)', padding: '6px 9px', cursor: 'pointer', fontSize: 10, fontWeight: 900, fontFamily: 'inherit' }}>{group}</button>
              ))}
            </div>
          )}
          {[grupoPreviewActivo].filter(Boolean).map(group => {
            const groupItems = ordered.filter(item => (item.group || 'Principal') === group && item.visible !== false);
            if (!groupItems.length) return null;
            return (
              <div key={`inside-${group}`} style={{ borderTop: '1px solid rgba(255,255,255,0.12)', paddingTop: 12 }}>
                <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: 10, fontWeight: 900, letterSpacing: 1.2, textTransform: 'uppercase', marginBottom: 8 }}>Al abrir "{group}"</div>
                <div {...dropProps(group)} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, minHeight: 112, border: arrastrando ? '1px dashed rgba(0,184,227,0.35)' : '1px dashed transparent', padding: arrastrando ? 6 : 0 }}>
                  {groupItems.slice(0, 4).map(item => (
                    <div key={item.id} {...dragProps(item.id)} {...dropProps(group, item.id)} style={{ border: `1px solid ${arrastrando === item.id ? '#00b8e3' : 'rgba(0,184,227,0.22)'}`, background: arrastrando === item.id ? 'rgba(0,184,227,0.16)' : 'rgba(0,184,227,0.07)', padding: 10, textAlign: 'center', cursor: 'grab' }}>
                      <div style={{ color: '#00b8e3', fontSize: 12, fontWeight: 900, marginBottom: 5 }}>{item.icon}</div>
                      <div style={{ color: '#fff', fontSize: 11, fontWeight: 800 }}>{item.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}

function OrganizarServicios() {
  const [grupos, setGrupos] = useState([]);
  const [catalogo, setCatalogo] = useState([]);
  const [sugeridos, setSugeridos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [categoriasDisponibles, setCategoriasDisponibles] = useState([]);
  const [buscar, setBuscar] = useState('');
  const [seleccion, setSeleccion] = useState(new Set());
  const [gruposSeleccionados, setGruposSeleccionados] = useState(new Set());
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ nombre: '', notas: '', precio_base: '', categoria: '', precios_cliente: [] });
  const [showForm, setShowForm] = useState(false);
  const [msg, setMsg] = useState('');
  const [guardando, setGuardando] = useState(false);

  const cargar = useCallback(async () => {
    const [g, c, s, l, cat] = await Promise.all([
      API.get('/servicios/grupos'),
      API.get('/servicios/catalogo'),
      API.get('/servicios/sugeridos'),
      API.get('/listas'),
      API.get('/servicios/categorias'),
    ]);
    setGrupos(Array.isArray(g.data) ? g.data : []);
    setCatalogo(Array.isArray(c.data) ? c.data : []);
    setSugeridos(Array.isArray(s.data) ? s.data : []);
    setClientes(Array.isArray(l.data?.clientes) ? l.data.clientes : []);
    setCategoriasDisponibles(Array.isArray(cat.data) ? cat.data : []);
  }, []);

  useEffect(() => { cargar().catch(() => setMsg('No se pudo cargar la organización de servicios')); }, [cargar]);

  const ocupados = new Set(grupos.flatMap(g => g.aliases));
  const disponibles = catalogo.filter(item =>
    (!ocupados.has(item.servicio) || seleccion.has(item.servicio)) &&
    (!buscar || item.servicio.toLocaleLowerCase('es').includes(buscar.toLocaleLowerCase('es')))
  );
  const seleccionados = [...seleccion];
  const gruposActivos = grupos.filter(grupo => gruposSeleccionados.has(grupo.id));
  const aliasesGruposActivos = gruposActivos.flatMap(grupo => grupo.aliases || []);
  const aliasesFinales = [...new Set([...aliasesGruposActivos, ...seleccionados])];
  const preciosAgrupados = gruposActivos.flatMap(grupo => grupo.precios_cliente || []).reduce((map, item) => {
    const key = String(item.cliente || '').toLocaleLowerCase('es');
    if (!map.has(key)) map.set(key, new Set());
    map.get(key).add(Number(item.precio));
    return map;
  }, new Map());
  const conflictosPrecio = [...preciosAgrupados.entries()].filter(([, valores]) => valores.size > 1);
  const impacto = aliasesFinales.reduce((acc, nombre) => {
    const item = catalogo.find(c => c.servicio === nombre);
    acc.registros += Number(item?.registros || 0);
    acc.valor += Number(item?.total_valor || 0);
    return acc;
  }, { registros: 0, valor: 0 });
  const money = value => '$' + Math.round(Number(value) || 0).toLocaleString('es-CO');

  function toggle(nombre) {
    setSeleccion(prev => {
      const next = new Set(prev);
      next.has(nombre) ? next.delete(nombre) : next.add(nombre);
      if (next.size > 0 && !showForm) {
        setEditando(null);
        setForm({ nombre: [...next][0] || '', notas: '', precio_base: '', categoria: '', precios_cliente: [] });
        setShowForm(true);
      }
      return next;
    });
  }

  function abrirNuevo(aliases = [], nombre = '') {
    setEditando(null);
    setGruposSeleccionados(new Set());
    setSeleccion(new Set(aliases));
    setForm({ nombre: nombre || aliases[0] || '', notas: '', precio_base: '', categoria: '', precios_cliente: [] });
    setShowForm(true);
    setMsg('');
  }

  function abrirEditar(grupo) {
    setEditando(grupo);
    setGruposSeleccionados(new Set([grupo.id]));
    setSeleccion(new Set(grupo.aliases));
    setForm({
      nombre: grupo.nombre,
      notas: grupo.notas || '',
      precio_base: grupo.precio_base ?? '',
      categoria: grupo.categoria || '',
      precios_cliente: (grupo.precios_cliente || []).map(item => ({ cliente: item.cliente, precio: item.precio })),
    });
    setShowForm(true);
    setMsg('');
  }

  function toggleGrupo(grupo) {
    setGruposSeleccionados(prev => {
      const next = new Set(prev);
      if (next.has(grupo.id)) next.delete(grupo.id);
      else next.add(grupo.id);
      const activos = grupos.filter(g => next.has(g.id));
      const precios = new Map();
      activos.flatMap(g => g.precios_cliente || []).forEach(item => {
        if (!precios.has(item.cliente)) precios.set(item.cliente, { cliente: item.cliente, precio: item.precio });
      });
      setSeleccion(sel => {
        const aliasesActivos = new Set(activos.flatMap(g => g.aliases || []));
        const siguiente = new Set([...sel].filter(alias => !ocupados.has(alias) || aliasesActivos.has(alias)));
        if (!activos.length && !siguiente.size) {
          setEditando(null);
          setShowForm(false);
        }
        return siguiente;
      });
      if (activos.length) {
        setEditando(activos.length === 1 ? activos[0] : null);
        setForm(actual => ({
          nombre: activos.length === 1 ? activos[0].nombre : (actual.nombre || activos[0].nombre),
          notas: activos.length === 1 ? (activos[0].notas || '') : actual.notas,
          precio_base: activos.length === 1 ? (activos[0].precio_base ?? '') : actual.precio_base,
          precios_cliente: [...precios.values()],
        }));
        setShowForm(true);
      }
      setMsg('');
      return next;
    });
  }

  async function guardar(event) {
    event.preventDefault();
    if (!aliasesFinales.length) { setMsg('Selecciona al menos un nombre histórico como alias'); return; }
    const preciosCliente = form.precios_cliente
      .map(item => ({ cliente: String(item.cliente || '').trim(), precio: item.precio }))
      .filter(item => item.cliente && item.precio !== '');
    const clientesPrecio = preciosCliente.map(item => item.cliente.toLocaleLowerCase('es'));
    if (new Set(clientesPrecio).size !== clientesPrecio.length) {
      setMsg('Un cliente no puede tener dos precios para el mismo servicio');
      return;
    }
    setGuardando(true);
    setMsg('');
    try {
      const payload = { ...form, precios_cliente: preciosCliente, aliases: aliasesFinales };
      if (gruposSeleccionados.size > 1) {
        await API.post('/servicios/grupos/fusionar', { ...payload, grupo_ids: [...gruposSeleccionados] });
      } else if (editando) await API.put(`/servicios/grupos/${editando.id}`, payload);
      else await API.post('/servicios/grupos', payload);
      setShowForm(false);
      setSeleccion(new Set());
      setGruposSeleccionados(new Set());
      setEditando(null);
      await cargar();
      setMsg('Organización de servicios guardada');
    } catch (error) {
      setMsg(error?.response?.data?.error || 'No se pudo guardar');
    } finally { setGuardando(false); }
  }

  async function eliminar(grupo) {
    if (!window.confirm(`¿Eliminar la organización "${grupo.nombre}"? Los registros históricos no se borrarán.`)) return;
    await API.delete(`/servicios/grupos/${grupo.id}`);
    await cargar();
    setMsg('Organización eliminada; los nombres históricos vuelven a verse por separado');
  }

  function agregarPrecioCliente() {
    setForm(f => ({ ...f, precios_cliente: [...f.precios_cliente, { cliente: '', precio: '' }] }));
  }

  function cambiarPrecioCliente(index, campo, valor) {
    setForm(f => ({
      ...f,
      precios_cliente: f.precios_cliente.map((item, i) => i === index ? { ...item, [campo]: valor } : item),
    }));
  }

  function eliminarPrecioCliente(index) {
    setForm(f => ({ ...f, precios_cliente: f.precios_cliente.filter((_, i) => i !== index) }));
  }

  function limpiarDecision() {
    setSeleccion(new Set());
    setGruposSeleccionados(new Set());
    setEditando(null);
    setShowForm(false);
    setForm({ nombre: '', notas: '', precio_base: '', categoria: '', precios_cliente: [] });
    setMsg('');
  }

  const card = { background: '#fff', border: '1px solid #e2eaf0', borderRadius: 4 };
  const input = { width: '100%', boxSizing: 'border-box', border: '1px solid #d8e5ec', padding: '9px 10px', fontFamily: 'inherit', color: '#08293f', background: '#fff' };

  return (
    <div>
      {msg && <div style={{ marginBottom: 12, color: msg.includes('No se') || msg.includes('Selecciona') ? '#dc2626' : '#047857', fontSize: 12, fontWeight: 700 }}>{msg}</div>}
      <div className="servicios-config-kpis" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,minmax(0,1fr))', gap: 8, marginBottom: 14 }}>
        {[
          ['Servicios principales', grupos.length],
          ['Alias organizados', ocupados.size],
          ['Sin organizar', catalogo.filter(c => !ocupados.has(c.servicio)).length],
          ['Sugerencias', sugeridos.length],
        ].map(([label, value], index) => (
          <div key={label} style={{ ...card, padding: '12px 14px', background: index === 0 ? '#08293f' : '#fff' }}>
            <div style={{ fontSize: 9, fontWeight: 800, color: index === 0 ? 'rgba(255,255,255,.6)' : '#6b8295', textTransform: 'uppercase', letterSpacing: 1 }}>{label}</div>
            <div style={{ fontSize: 22, fontWeight: 900, color: index === 0 ? '#00b8e3' : '#08293f', marginTop: 5 }}>{value}</div>
          </div>
        ))}
      </div>

      <div className="servicios-config-layout" style={{ display: 'grid', gridTemplateColumns: 'minmax(320px,.85fr) minmax(420px,1.15fr)', gap: 12, alignItems: 'start' }}>
        <div style={{ display: 'grid', gap: 12 }}>
          <section style={{ ...card, overflow: 'hidden' }}>
            <div style={{ padding: '12px 14px', background: '#f7fafc', borderBottom: '1px solid #e2eaf0' }}>
              <b style={{ color: '#08293f', fontSize: 12 }}>Sugerencias por similitud</b>
              <div style={{ color: '#6b8295', fontSize: 11, marginTop: 3 }}>Solo son propuestas; debes revisarlas antes de unir.</div>
            </div>
            <div style={{ maxHeight: 310, overflowY: 'auto', padding: 10, display: 'grid', gap: 8 }}>
              {sugeridos.map((item, index) => (
                <div key={`${item.servicios.join('|')}-${index}`} style={{ border: '1px solid #e2eaf0', padding: 10 }}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 8 }}>
                    {item.servicios.map(nombre => <span key={nombre} style={{ fontSize: 11, color: '#075985', background: '#e8f8fc', padding: '3px 7px' }}>{nombre}</span>)}
                  </div>
                  <div style={{ color: '#6b8295', fontSize: 10, marginBottom: 8 }}>{item.registros} registros · {money(item.total_valor)}</div>
                  <button onClick={() => abrirNuevo(item.servicios, item.servicios[0])} style={{ border: 'none', background: '#08293f', color: '#fff', padding: '6px 9px', fontWeight: 800, cursor: 'pointer', fontSize: 11 }}>Revisar y organizar</button>
                </div>
              ))}
              {!sugeridos.length && <div style={{ color: '#6b8295', fontSize: 12, textAlign: 'center', padding: 20 }}>Sin sugerencias pendientes</div>}
            </div>
          </section>

          <section style={{ ...card, overflow: 'hidden' }}>
            <div style={{ padding: '12px 14px', background: '#f7fafc', borderBottom: '1px solid #e2eaf0' }}>
              <b style={{ color: '#08293f', fontSize: 12 }}>Servicios históricos sin organizar</b>
            </div>
            <div style={{ padding: 10 }}>
              <input value={buscar} onChange={e => setBuscar(e.target.value)} placeholder="Buscar servicio..." style={{ ...input, marginBottom: 8 }} />
              <div style={{ maxHeight: 330, overflowY: 'auto', border: '1px solid #edf2f5' }}>
                {disponibles.map(item => (
                  <label key={item.servicio} style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '8px 9px', borderTop: '1px solid #edf2f5', background: seleccion.has(item.servicio) ? '#ecfaff' : '#fff', cursor: 'pointer' }}>
                    <input type="checkbox" checked={seleccion.has(item.servicio)} onChange={() => toggle(item.servicio)} />
                    <span style={{ flex: 1, color: '#08293f', fontSize: 11, fontWeight: 700 }}>{item.servicio}</span>
                    <span style={{ color: '#6b8295', fontSize: 10 }}>{item.registros} · {money(item.precio_promedio)}</span>
                  </label>
                ))}
              </div>
              {seleccion.size > 0 && (
                <button onClick={() => abrirNuevo(seleccionados)} style={{ marginTop: 9, border: 'none', background: '#00b8e3', color: '#fff', padding: '8px 11px', fontWeight: 800, cursor: 'pointer' }}>
                  Organizar seleccionados ({seleccion.size})
                </button>
              )}
            </div>
          </section>
        </div>

        <section style={{ ...card, overflow: 'hidden' }}>
          <div style={{ padding: '12px 14px', background: '#f7fafc', borderBottom: '1px solid #e2eaf0', display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'center' }}>
            <div><b style={{ color: '#08293f', fontSize: 12 }}>{showForm ? 'Mesa de decisión' : 'Servicios principales'}</b><div style={{ color: '#6b8295', fontSize: 11, marginTop: 3 }}>{showForm ? 'Define cómo quedará la selección antes de guardar.' : 'Puedes editarlos o volver a unirlos con otros servicios.'}</div></div>
            <button onClick={() => abrirNuevo()} style={{ border: 'none', background: '#00b8e3', color: '#fff', padding: '7px 10px', fontWeight: 800, cursor: 'pointer' }}>+ Nuevo</button>
          </div>

          {showForm && (
            <form onSubmit={guardar} style={{ padding: 14, borderBottom: '1px solid #d8e5ec', background: '#fbfdff' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'flex-start', marginBottom: 12 }}>
                <div>
                  <div style={{ color: '#08293f', fontWeight: 900, fontSize: 13 }}>{gruposSeleccionados.size > 1 ? `Fusionar ${gruposSeleccionados.size} servicios principales` : editando ? 'Editar servicio principal' : 'Crear servicio principal'}</div>
                  <div style={{ color: '#6b8295', fontSize: 11, marginTop: 3 }}>El histórico conserva sus nombres, clientes, fechas y valores originales.</div>
                </div>
                <button type="button" onClick={limpiarDecision} style={{ border: 'none', background: 'none', color: '#6b8295', cursor: 'pointer', fontSize: 18 }}>×</button>
              </div>

              <label style={{ display: 'grid', gap: 4, color: '#6b8295', fontSize: 11, fontWeight: 800, marginBottom: 9 }}>Nombre con el que quedará *
                <input required value={form.nombre} onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))} style={input} />
              </label>
              <label style={{ display: 'grid', gap: 4, color: '#6b8295', fontSize: 11, fontWeight: 800, marginBottom: 10 }}>Notas
                <input value={form.notas} onChange={e => setForm(f => ({ ...f, notas: e.target.value }))} placeholder="Qué incluye este servicio" style={input} />
              </label>

              <label style={{ display: 'grid', gap: 4, color: '#6b8295', fontSize: 11, fontWeight: 800, marginBottom: 10 }}>Categoría (para Rentabilidad)
                <input
                  list="categorias-servicio-lista"
                  value={form.categoria}
                  onChange={e => setForm(f => ({ ...f, categoria: e.target.value }))}
                  placeholder="Ej. Web Service, Soporte y mensualidad..."
                  style={input}
                />
                <datalist id="categorias-servicio-lista">
                  {categoriasDisponibles.map(c => <option key={c} value={c} />)}
                </datalist>
              </label>

              <div style={{ border: '1px solid #d8e5ec', background: '#f7fafc', padding: 10, marginBottom: 10 }}>
                <label style={{ display: 'grid', gap: 4, color: '#6b8295', fontSize: 11, fontWeight: 800 }}>Precio base sugerido
                  <input type="number" min="0" value={form.precio_base} onChange={e => setForm(f => ({ ...f, precio_base: e.target.value }))} placeholder="Opcional" style={input} />
                </label>
                <div style={{ color: '#6b8295', fontSize: 10, lineHeight: 1.45, marginTop: 5 }}>Si los nombres seleccionados tuvieron precios diferentes, abajo puedes comparar sus promedios. Este precio base será una sugerencia, no una corrección del histórico.</div>
                {conflictosPrecio.length > 0 && (
                  <div style={{ marginTop: 7, padding: '7px 8px', background: '#fff7ed', border: '1px solid #fed7aa', color: '#9a5310', fontSize: 10, fontWeight: 700 }}>
                    Hay {conflictosPrecio.length} cliente(s) con precios diferentes entre los servicios seleccionados. Revisa abajo el valor que deseas conservar.
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'center', marginTop: 10, marginBottom: 6 }}>
                  <div style={{ color: '#6b8295', fontSize: 11, fontWeight: 800 }}>Precios especiales por cliente</div>
                  <button type="button" onClick={agregarPrecioCliente} style={{ border: '1px solid #b9dce7', background: '#fff', color: '#0087a8', padding: '4px 7px', fontWeight: 800, cursor: 'pointer', fontSize: 10 }}>+ Cliente</button>
                </div>
                <datalist id="servicio-clientes-precio-panel">{clientes.map(cliente => <option key={cliente} value={cliente} />)}</datalist>
                <div style={{ display: 'grid', gap: 5 }}>
                  {form.precios_cliente.map((item, index) => (
                    <div key={index} className="servicio-precio-cliente-row" style={{ display: 'grid', gridTemplateColumns: '1fr 125px 30px', gap: 5 }}>
                      <input list="servicio-clientes-precio-panel" value={item.cliente} onChange={e => cambiarPrecioCliente(index, 'cliente', e.target.value)} placeholder="Cliente" style={input} />
                      <input type="number" min="0" value={item.precio} onChange={e => cambiarPrecioCliente(index, 'precio', e.target.value)} placeholder="Precio" style={input} />
                      <button type="button" onClick={() => eliminarPrecioCliente(index)} style={{ border: '1px solid #f1c9c9', background: '#fff', color: '#dc2626', cursor: 'pointer', fontWeight: 900 }}>×</button>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ color: '#6b8295', fontSize: 11, fontWeight: 800, marginBottom: 6 }}>Nombres incluidos ({aliasesFinales.length})</div>
              <div style={{ maxHeight: 230, overflowY: 'auto', border: '1px solid #e2eaf0', marginBottom: 8 }}>
                {aliasesFinales.map(alias => {
                  const item = catalogo.find(c => c.servicio === alias);
                  return (
                    <div key={alias} style={{ display: 'grid', gridTemplateColumns: '1fr auto auto', gap: 8, alignItems: 'center', padding: '7px 9px', borderTop: '1px solid #edf2f5', background: '#fff' }}>
                      <span style={{ color: '#08293f', fontSize: 11, fontWeight: 700 }}>{alias}</span>
                      <span style={{ color: '#6b8295', fontSize: 10 }}>{item?.registros || 0} reg.</span>
                      <span style={{ color: '#047857', fontSize: 10, fontWeight: 800 }}>prom. {money(item?.precio_promedio)}</span>
                    </div>
                  );
                })}
                {!aliasesFinales.length && <div style={{ color: '#8aa0b0', fontSize: 11, padding: 14 }}>Selecciona servicios históricos o un servicio principal existente.</div>}
              </div>
              <div style={{ color: '#6b8295', fontSize: 11 }}>{impacto.registros} registros históricos · {money(impacto.valor)} asociados</div>
              <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                <button disabled={guardando || !aliasesFinales.length} type="submit" style={{ border: 'none', background: '#00b8e3', color: '#fff', padding: '9px 12px', fontWeight: 800, cursor: 'pointer', opacity: aliasesFinales.length ? 1 : .5 }}>{guardando ? 'Guardando...' : gruposSeleccionados.size > 1 ? 'Fusionar servicios' : 'Guardar organización'}</button>
                <button type="button" onClick={limpiarDecision} style={{ border: '1px solid #d8e5ec', background: '#fff', color: '#08293f', padding: '9px 12px', fontWeight: 700, cursor: 'pointer' }}>Cancelar</button>
              </div>
            </form>
          )}

          <div style={{ padding: '10px 12px', color: '#6b8295', fontSize: 10, fontWeight: 800, textTransform: 'uppercase', letterSpacing: .8, background: '#f7fafc', borderBottom: '1px solid #e2eaf0' }}>Servicios ya organizados</div>
          <div style={{ display: 'grid', gap: 8, padding: 10, maxHeight: showForm ? 380 : 650, overflowY: 'auto' }}>
            {grupos.map(grupo => (
              <div key={grupo.id} style={{ border: `1px solid ${gruposSeleccionados.has(grupo.id) ? '#00b8e3' : '#e2eaf0'}`, background: gruposSeleccionados.has(grupo.id) ? '#ecfaff' : '#fff', padding: '12px 13px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'flex-start' }}>
                  <div>
                    <label style={{ display: 'flex', gap: 7, alignItems: 'center', cursor: 'pointer' }}>
                      <input type="checkbox" checked={gruposSeleccionados.has(grupo.id)} onChange={() => toggleGrupo(grupo)} />
                      <b style={{ color: '#08293f' }}>{grupo.nombre}</b>
                    </label>
                    {grupo.notas && <div style={{ color: '#6b8295', fontSize: 11, marginTop: 3 }}>{grupo.notas}</div>}
                    {grupo.categoria && (
                      <span style={{ display: 'inline-block', marginTop: 4, fontSize: 10, fontWeight: 800, padding: '2px 7px', borderRadius: 20, background: 'rgba(0,184,227,0.1)', color: '#0284c7' }}>{grupo.categoria}</span>
                    )}
                    <div style={{ color: '#047857', fontSize: 11, fontWeight: 800, marginTop: 5 }}>
                      {grupo.precio_base != null ? `Precio base ${money(grupo.precio_base)}` : 'Sin precio base'}
                      {(grupo.precios_cliente || []).length > 0 && ` · ${grupo.precios_cliente.length} precio(s) por cliente`}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={() => abrirEditar(grupo)} style={{ border: 'none', background: 'none', color: '#0087a8', cursor: 'pointer', fontWeight: 700 }}>Editar</button>
                    <button onClick={() => eliminar(grupo)} style={{ border: 'none', background: 'none', color: '#dc2626', cursor: 'pointer', fontWeight: 700 }}>Eliminar</button>
                  </div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginTop: 9 }}>
                  {grupo.aliases.map(alias => <span key={alias} style={{ color: '#075985', background: '#e8f8fc', border: '1px solid #c8edf5', padding: '3px 8px', fontSize: 10 }}>{alias}</span>)}
                </div>
              </div>
            ))}
            {!grupos.length && <div style={{ color: '#6b8295', fontSize: 12, textAlign: 'center', padding: 30 }}>Todavía no hay servicios organizados.</div>}
          </div>
        </section>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .servicios-config-kpis { grid-template-columns: 1fr 1fr !important; }
          .servicios-config-layout { grid-template-columns: 1fr !important; }
          .servicio-precio-cliente-row { grid-template-columns: 1fr 120px 34px !important; }
        }
      `}</style>
    </div>
  );
}

function OrganizarProveedores() {
  const empty = { nombre: '', nit: '', direccion: '', correo: '', telefono: '', contacto: '', notas: '' };
  const [proveedores, setProveedores] = useState([]);
  const [buscar, setBuscar] = useState('');
  const [seleccionado, setSeleccionado] = useState(null);
  const [form, setForm] = useState(empty);
  const [msg, setMsg] = useState('');
  const [guardando, setGuardando] = useState(false);
  const money = value => '$' + Math.round(Number(value) || 0).toLocaleString('es-CO');
  const input = { width: '100%', boxSizing: 'border-box', border: '1px solid #d8e5ec', padding: '9px 10px', fontFamily: 'inherit', color: '#08293f', background: '#fff' };
  const card = { background: '#fff', border: '1px solid #e2eaf0', borderRadius: 4 };

  const cargar = useCallback(async () => {
    const r = await API.get('/proveedores', { params: buscar.trim() ? { q: buscar.trim() } : {} });
    setProveedores(Array.isArray(r.data) ? r.data : []);
  }, [buscar]);

  useEffect(() => { cargar().catch(() => setMsg('No se pudieron cargar proveedores')); }, [cargar]);

  function nuevo() {
    setSeleccionado(null);
    setForm({ ...empty, nombre: buscar.trim() });
    setMsg('');
  }

  async function abrir(proveedor) {
    setMsg('');
    try {
      const r = await API.get(`/proveedores/${encodeURIComponent(proveedor.nombre)}`);
      setSeleccionado(r.data);
      setForm({
        nombre: r.data.nombre || '',
        nit: r.data.nit || '',
        direccion: r.data.direccion || '',
        correo: r.data.correo || '',
        telefono: r.data.telefono || '',
        contacto: r.data.contacto || '',
        notas: r.data.notas || '',
      });
    } catch (err) {
      setMsg(err?.response?.data?.error || 'No se pudo cargar la ficha');
    }
  }

  async function guardar(e) {
    e.preventDefault();
    setGuardando(true);
    setMsg('');
    try {
      if (seleccionado?.nombre) await API.put(`/proveedores/${encodeURIComponent(seleccionado.nombre)}`, form);
      else await API.post('/proveedores', form);
      setMsg('Proveedor guardado');
      await cargar();
      const r = await API.get(`/proveedores/${encodeURIComponent(form.nombre)}`);
      setSeleccionado(r.data);
    } catch (err) {
      setMsg(err?.response?.data?.error || 'No se pudo guardar');
    } finally {
      setGuardando(false);
    }
  }

  async function eliminar() {
    if (!seleccionado?.nombre) return;
    if (!window.confirm(`Eliminar proveedor ${seleccionado.nombre}?`)) return;
    try {
      await API.delete(`/proveedores/${encodeURIComponent(seleccionado.nombre)}`);
      setMsg('Proveedor eliminado');
      setSeleccionado(null);
      setForm(empty);
      await cargar();
    } catch (err) {
      setMsg(err?.response?.data?.error || 'No se pudo eliminar');
    }
  }

  const stats = seleccionado?.stats || {};
  return (
    <div className="proveedores-config-layout" style={{ display: 'grid', gridTemplateColumns: 'minmax(280px, 390px) minmax(320px, 1fr)', gap: 14, alignItems: 'start' }}>
      <section style={{ ...card, padding: 16 }}>
        <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1 }}>Proveedores</div>
        <h2 style={{ color: '#08293f', fontSize: 18, margin: '7px 0' }}>Organizar proveedores</h2>
        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          <input value={buscar} onChange={e => setBuscar(e.target.value)} placeholder="Buscar proveedor..." style={input} />
          <button type="button" onClick={nuevo} style={{ border: 'none', background: '#00b8e3', color: '#fff', padding: '0 13px', fontWeight: 800, cursor: 'pointer' }}>Nuevo</button>
        </div>
        <div style={{ display: 'grid', gap: 7, maxHeight: 520, overflowY: 'auto' }}>
          {proveedores.map(p => (
            <button key={p.nombre} type="button" onClick={() => abrir(p)} style={{ textAlign: 'left', border: `1px solid ${seleccionado?.nombre === p.nombre ? '#00b8e3' : '#e2eaf0'}`, background: seleccionado?.nombre === p.nombre ? '#ecfaff' : '#fff', padding: 11, cursor: 'pointer', fontFamily: 'inherit' }}>
              <b style={{ color: '#08293f' }}>{p.nombre}</b>
              <div style={{ color: '#6b8295', fontSize: 11, marginTop: 3 }}>{p.nit || 'Sin NIT'} · {Number(p.registros || 0)} registro(s)</div>
            </button>
          ))}
          {!proveedores.length && <div style={{ color: '#6b8295', fontSize: 12, padding: 12 }}>Sin proveedores.</div>}
        </div>
      </section>

      <section style={{ ...card, padding: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start', marginBottom: 12 }}>
          <div>
            <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1 }}>Ficha del proveedor</div>
            <h2 style={{ color: '#08293f', fontSize: 20, margin: '7px 0 0' }}>{form.nombre || 'Nuevo proveedor'}</h2>
          </div>
          {seleccionado?.nombre && <button type="button" onClick={eliminar} style={{ border: '1px solid #fecaca', background: '#fff7f7', color: '#dc2626', padding: '7px 10px', fontWeight: 800, cursor: 'pointer' }}>Eliminar</button>}
        </div>
        {seleccionado?.nombre && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(145px, 1fr))', gap: 8, marginBottom: 14 }}>
            {[
              ['Registros', stats.registros || 0],
              ['Valor registros', money(stats.valor_registros)],
              ['Utilidad', money(stats.utilidad_registros)],
              ['Gastos', stats.gastos || 0],
              ['Valor gastos', money(stats.valor_gastos)],
            ].map(([label, value]) => <div key={label} style={{ background: '#f7fafd', border: '1px solid #e2eaf0', padding: 10 }}><div style={{ color: '#6b8295', fontSize: 10, fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1 }}>{label}</div><div style={{ color: '#08293f', fontSize: 16, fontWeight: 900, marginTop: 4 }}>{value}</div></div>)}
          </div>
        )}
        <form onSubmit={guardar}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 10 }}>
            {[
              ['nombre', 'Nombre *'],
              ['nit', 'NIT / Documento'],
              ['direccion', 'Direccion'],
              ['correo', 'Correo'],
              ['telefono', 'Telefono'],
              ['contacto', 'Contacto'],
            ].map(([key, label]) => (
              <label key={key} style={{ display: 'grid', gap: 4, color: '#6b8295', fontSize: 11, fontWeight: 800 }}>
                {label}
                <input required={key === 'nombre'} value={form[key]} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={input} />
              </label>
            ))}
          </div>
          <label style={{ display: 'grid', gap: 4, color: '#6b8295', fontSize: 11, fontWeight: 800, marginTop: 10 }}>
            Notas
            <textarea rows={4} value={form.notas} onChange={e => setForm(f => ({ ...f, notas: e.target.value }))} style={{ ...input, resize: 'vertical' }} />
          </label>
          <div style={{ display: 'flex', gap: 8, marginTop: 12, alignItems: 'center' }}>
            <button type="submit" disabled={guardando} style={{ border: 'none', background: '#08293f', color: '#fff', padding: '10px 16px', fontWeight: 800, cursor: 'pointer' }}>{guardando ? 'Guardando...' : 'Guardar proveedor'}</button>
            {msg && <span style={{ color: msg.includes('No se') ? '#dc2626' : '#047857', fontSize: 12, fontWeight: 800 }}>{msg}</span>}
          </div>
        </form>
      </section>
      <style>{`@media (max-width: 900px) { .proveedores-config-layout { grid-template-columns: 1fr !important; } }`}</style>
    </div>
  );
}

export default function Configuracion() {
  const [tab, setTab] = useState('usuarios');
  const [usuarios, setUsuarios] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [seleccionEmpresas, setSeleccionEmpresas] = useState([]);
  const [busquedaEmpresa, setBusquedaEmpresa] = useState('');
  const [msg, setMsg] = useState('');
  const [guardando, setGuardando] = useState(false);

  const cargar = useCallback(async () => {
    const [u, e] = await Promise.all([API.get('/configuracion/usuarios'), API.get('/empresas-lista')]);
    setUsuarios(Array.isArray(u.data) ? u.data : []);
    setEmpresas(Array.isArray(e.data) ? e.data : []);
  }, []);

  useEffect(() => { cargar().catch(() => setMsg('No se pudo cargar la configuración')); }, [cargar]);

  function nuevoUsuario() {
    setEditando('nuevo');
    setForm(emptyForm);
    setSeleccionEmpresas([]);
    setMsg('');
  }

  function editarUsuario(usuario) {
    setEditando(usuario.id);
    setForm({ nombre: usuario.nombre, email: usuario.email, password: '', rol: usuario.rol, activo: !!usuario.activo });
    setSeleccionEmpresas(usuario.empresas || []);
    setMsg('');
  }

  async function guardarUsuario(e) {
    e.preventDefault();
    setGuardando(true);
    setMsg('');
    try {
      let id = editando;
      if (editando === 'nuevo') {
        const r = await API.post('/configuracion/usuarios', form);
        id = r.data.id;
      } else {
        await API.put(`/configuracion/usuarios/${editando}`, form);
      }
      await API.put(`/configuracion/usuarios/${id}/empresas`, { empresas: seleccionEmpresas });
      await cargar();
      setEditando(null);
      setMsg('Usuario y permisos guardados');
    } catch (err) {
      setMsg(err?.response?.data?.error || 'No se pudo guardar');
    } finally {
      setGuardando(false);
    }
  }

  function toggleEmpresa(nombre) {
    setSeleccionEmpresas(prev => prev.includes(nombre) ? prev.filter(x => x !== nombre) : [...prev, nombre]);
  }

  async function descargarArchivo(endpoint, nombreBase) {
    setMsg('Generando respaldo...');
    try {
      const r = await API.get(endpoint, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      const disposition = r.headers['content-disposition'] || '';
      const match = disposition.match(/filename="?([^"]+)"?/i);
      a.download = match?.[1] || `${nombreBase}_${new Date().toISOString().slice(0, 10)}`;
      a.click();
      URL.revokeObjectURL(url);
      setMsg('Respaldo descargado');
    } catch (err) {
      setMsg(err?.response?.data?.error || 'No se pudo generar el respaldo');
    }
  }

  const empresasFiltradas = empresas.filter(e => e.nombre.toLocaleLowerCase('es').includes(busquedaEmpresa.toLocaleLowerCase('es')));
  const card = { background: '#fff', border: '1px solid #e2eaf0', borderRadius: 4 };
  const input = { width: '100%', boxSizing: 'border-box', border: '1px solid #d8e5ec', padding: '9px 10px', fontFamily: 'inherit', color: '#08293f', background: '#fff' };

  return (
    <div>
      <div style={{ marginBottom: 18 }}>
        <h1 style={{ margin: 0, color: '#08293f', fontSize: 20 }}>Configuración</h1>
        <div style={{ color: '#6b8295', fontSize: 12, marginTop: 4 }}>Usuarios, permisos, respaldos y ajustes generales del software.</div>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, borderBottom: '1px solid #d8e5ec', marginBottom: 16 }}>
        {[['usuarios', 'Usuarios y permisos'], ['registros', 'Registros y datos'], ['panel', 'Panel principal'], ['frases', 'Frases'], ['contactos', 'Organizar clientes'], ['servicios', 'Organizar servicios'], ['proveedores', 'Organizar proveedores'], ['backups', 'Respaldos']].map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)} style={{ border: 'none', borderBottom: tab === key ? '2px solid #00b8e3' : '2px solid transparent', background: 'transparent', color: tab === key ? '#08293f' : '#6b8295', padding: '9px 14px', fontWeight: 700, cursor: 'pointer' }}>{label}</button>
        ))}
      </div>

      {msg && <div style={{ marginBottom: 12, color: msg.includes('No se') ? '#dc2626' : '#047857', fontSize: 12, fontWeight: 700 }}>{msg}</div>}

      {tab === 'registros' && <RegistrosDatos card={card} input={input} setMsg={setMsg} />}

      {tab === 'panel' && <PanelPrincipalEditor card={card} input={input} setMsg={setMsg} />}

      {tab === 'frases' && <FrasesEditor card={card} input={input} setMsg={setMsg} />}

      {tab === 'servicios' && <OrganizarServicios />}
      {tab === 'proveedores' && <OrganizarProveedores />}
      {tab === 'contactos' && <TabGrupos />}

      {tab === 'backups' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 12, maxWidth: 980 }}>
          <section style={{ ...card, padding: 18 }}>
            <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1 }}>Software</div>
            <h2 style={{ color: '#08293f', fontSize: 17, margin: '7px 0' }}>Estructura y código</h2>
            <p style={{ color: '#5a7185', fontSize: 12, lineHeight: 1.6, margin: '0 0 16px' }}>Archivo comprimido con backend, código fuente del frontend y archivos de configuración del proyecto. Excluye contraseñas, dependencias y archivos temporales.</p>
            <button onClick={() => descargarArchivo('/configuracion/backup-software', 'ageinformatica_software.tar.gz')} style={{ border: 'none', background: '#08293f', color: '#fff', padding: '10px 16px', fontWeight: 800, cursor: 'pointer' }}>Descargar software</button>
          </section>
          <section style={{ ...card, padding: 18 }}>
            <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1 }}>Base de datos</div>
            <h2 style={{ color: '#08293f', fontSize: 17, margin: '7px 0' }}>Estructura y datos completos</h2>
            <p style={{ color: '#5a7185', fontSize: 12, lineHeight: 1.6, margin: '0 0 16px' }}>Archivo SQL restaurable con tablas, índices, relaciones y todos los registros actuales del sistema.</p>
            <button onClick={() => descargarArchivo('/configuracion/backup-datos', 'ageinformatica_base_datos.sql')} style={{ border: 'none', background: '#00b8e3', color: '#fff', padding: '10px 16px', fontWeight: 800, cursor: 'pointer' }}>Descargar datos</button>
          </section>
          <section style={{ ...card, padding: 18 }}>
            <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1 }}>Datos contables</div>
            <h2 style={{ color: '#08293f', fontSize: 17, margin: '7px 0' }}>Exportación legible</h2>
            <p style={{ color: '#5a7185', fontSize: 12, lineHeight: 1.6, margin: '0 0 16px' }}>Archivo JSON para consultar registros, clientes, gastos, servicios, proveedores, CDT y academia sin restaurar una base de datos.</p>
            <button onClick={() => descargarArchivo('/ajustes/backup-contable', 'backup_contable.json')} style={{ border: '1px solid #d8e5ec', background: '#fff', color: '#08293f', padding: '10px 16px', fontWeight: 800, cursor: 'pointer' }}>Descargar JSON</button>
          </section>
        </div>
      )}

      {tab === 'usuarios' && !editando && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <div style={{ color: '#6b8295', fontSize: 12 }}>{usuarios.length} usuarios registrados</div>
            <button onClick={nuevoUsuario} style={{ border: 'none', background: '#00b8e3', color: '#fff', padding: '9px 14px', fontWeight: 800, cursor: 'pointer' }}>+ Nuevo usuario</button>
          </div>
          <div style={{ ...card, overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 720 }}>
              <thead><tr style={{ background: '#f5f8fa' }}>{['Usuario', 'Correo', 'Rol', 'Empresas', 'Estado', ''].map(h => <th key={h} style={{ textAlign: 'left', padding: 10, fontSize: 10, color: '#6b8295', textTransform: 'uppercase', letterSpacing: 1 }}>{h}</th>)}</tr></thead>
              <tbody>{usuarios.map(u => (
                <tr key={u.id} style={{ borderTop: '1px solid #edf2f5' }}>
                  <td style={{ padding: 11, color: '#08293f', fontWeight: 800 }}>{u.nombre}</td>
                  <td style={{ padding: 11, color: '#526c80', fontSize: 12 }}>{u.email}</td>
                  <td style={{ padding: 11, color: '#08293f', fontSize: 12 }}>{ROLES.find(r => r[0] === u.rol)?.[1] || u.rol}</td>
                  <td style={{ padding: 11, color: '#526c80', fontSize: 12 }}>{u.empresas.length ? `${u.empresas.length} asignada${u.empresas.length === 1 ? '' : 's'}` : 'Sin asignar'}</td>
                  <td style={{ padding: 11 }}><span style={{ color: u.activo ? '#047857' : '#dc2626', fontSize: 11, fontWeight: 800 }}>{u.activo ? 'Activo' : 'Inactivo'}</span></td>
                  <td style={{ padding: 11, textAlign: 'right' }}><button onClick={() => editarUsuario(u)} style={{ border: '1px solid #d8e5ec', background: '#fff', color: '#08293f', padding: '6px 10px', fontWeight: 700, cursor: 'pointer' }}>Editar</button></td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </>
      )}

      {tab === 'usuarios' && editando && (
        <form onSubmit={guardarUsuario} style={{ display: 'grid', gridTemplateColumns: 'minmax(280px, 420px) minmax(320px, 1fr)', gap: 14, alignItems: 'start' }}>
          <section style={{ ...card, padding: 16 }}>
            <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>{editando === 'nuevo' ? 'Nuevo usuario' : 'Editar usuario'}</div>
            {[['nombre', 'Nombre', 'text'], ['email', 'Correo', 'email'], ['password', editando === 'nuevo' ? 'Contraseña' : 'Nueva contraseña (opcional)', 'password']].map(([key, label, type]) => (
              <label key={key} style={{ display: 'grid', gap: 4, marginBottom: 11, color: '#6b8295', fontSize: 11, fontWeight: 700 }}>{label}<input required={editando === 'nuevo' || key !== 'password'} type={type} value={form[key]} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={input} /></label>
            ))}
            <label style={{ display: 'grid', gap: 4, marginBottom: 12, color: '#6b8295', fontSize: 11, fontWeight: 700 }}>Rol
              <select value={form.rol} onChange={e => setForm(f => ({ ...f, rol: e.target.value }))} style={input}>{ROLES.map(([value, label]) => <option key={value} value={value}>{label}</option>)}</select>
            </label>
            <label style={{ display: 'flex', gap: 8, alignItems: 'center', color: '#08293f', fontSize: 12, fontWeight: 700 }}><input type="checkbox" checked={form.activo} onChange={e => setForm(f => ({ ...f, activo: e.target.checked }))} /> Usuario activo</label>
            <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
              <button disabled={guardando} type="submit" style={{ border: 'none', background: '#00b8e3', color: '#fff', padding: '9px 14px', fontWeight: 800, cursor: 'pointer' }}>{guardando ? 'Guardando...' : 'Guardar'}</button>
              <button type="button" onClick={() => setEditando(null)} style={{ border: '1px solid #d8e5ec', background: '#fff', color: '#08293f', padding: '9px 14px', fontWeight: 700, cursor: 'pointer' }}>Cancelar</button>
            </div>
          </section>

          <section style={{ ...card, padding: 16 }}>
            <div style={{ fontSize: 11, color: '#6b8295', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1 }}>Empresas permitidas</div>
            <div style={{ color: '#5a7185', fontSize: 12, margin: '5px 0 12px' }}>Para Recursos humanos, estas serán las únicas empresas e inventarios visibles.</div>
            <input value={busquedaEmpresa} onChange={e => setBusquedaEmpresa(e.target.value)} placeholder="Buscar empresa..." style={{ ...input, marginBottom: 10 }} />
            <div style={{ maxHeight: 430, overflowY: 'auto', border: '1px solid #e2eaf0' }}>
              {empresasFiltradas.map(e => {
                const checked = seleccionEmpresas.includes(e.nombre);
                return <label key={e.nombre} style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '9px 11px', borderTop: '1px solid #edf2f5', background: checked ? '#ecfaff' : '#fff', color: '#08293f', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}><input type="checkbox" checked={checked} onChange={() => toggleEmpresa(e.nombre)} />{e.nombre}</label>;
              })}
            </div>
            <div style={{ color: '#6b8295', fontSize: 11, marginTop: 8 }}>{seleccionEmpresas.length} empresas seleccionadas</div>
          </section>
        </form>
      )}
    </div>
  );
}

function FrasesEditor({ card, input, setMsg }) {
  const [frases, setFrases] = useState([]);
  const [nueva, setNueva] = useState('');
  const [editId, setEditId] = useState(null);
  const [editTexto, setEditTexto] = useState('');
  const [cargando, setCargando] = useState(false);

  const cargar = useCallback(() => {
    API.get('/frases')
      .then(r => setFrases(Array.isArray(r.data) ? r.data : []))
      .catch(e => setMsg('No se pudieron cargar las frases: ' + (e.response?.data?.error || e.message)));
  }, [setMsg]);

  useEffect(() => { cargar(); }, [cargar]);

  const correr = async (fn, ok) => {
    setCargando(true);
    try {
      await fn();
      cargar();
      setMsg(ok);
    } catch (e) {
      setMsg('No se pudo guardar: ' + (e.response?.data?.error || e.message));
    } finally {
      setCargando(false);
    }
  };

  const agregar = e => {
    e.preventDefault();
    const texto = nueva.trim();
    if (!texto) return;
    correr(() => API.post('/frases', { texto }), 'Frase agregada').then(() => setNueva(''));
  };

  return (
    <div style={{ maxWidth: 820 }}>
      <div style={{ ...card, padding: 16, marginBottom: 14 }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: '#08293f', marginBottom: 4 }}>Frases de mentalidad</div>
        <div style={{ fontSize: 12, color: '#6b8295', marginBottom: 12 }}>
          Se muestra una al azar en la parte superior del módulo de Inversiones cada vez que entras.
        </div>
        <form onSubmit={agregar} style={{ display: 'flex', gap: 8 }}>
          <input
            style={{ ...input, flex: 1 }}
            placeholder="Escribe una frase nueva"
            value={nueva}
            maxLength={300}
            onChange={e => setNueva(e.target.value)}
          />
          <button className="btn-primary" disabled={cargando || !nueva.trim()}>Agregar</button>
        </form>
      </div>

      <div style={{ ...card, padding: 0 }}>
        {!frases.length ? (
          <div style={{ padding: 16, fontSize: 12, color: '#6b8295' }}>Aún no hay frases.</div>
        ) : frases.map(f => (
          <div key={f.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '11px 14px', borderBottom: '1px solid #eef2f6' }}>
            {editId === f.id ? (
              <>
                <input style={{ ...input, flex: 1 }} value={editTexto} maxLength={300} onChange={e => setEditTexto(e.target.value)} />
                <button
                  className="btn-primary"
                  disabled={cargando || !editTexto.trim()}
                  onClick={() => correr(() => API.put(`/frases/${f.id}`, { texto: editTexto.trim(), activa: f.activa }), 'Frase actualizada').then(() => setEditId(null))}
                  style={{ padding: '6px 11px', fontSize: 12 }}
                >Guardar</button>
                <button className="btn-secondary" onClick={() => setEditId(null)} style={{ padding: '6px 11px', fontSize: 12 }}>Cancelar</button>
              </>
            ) : (
              <>
                <span style={{ flex: 1, fontSize: 13, color: f.activa ? '#08293f' : '#9bb0c0', fontStyle: 'italic' }}>
                  {f.texto}
                </span>
                <button
                  onClick={() => correr(() => API.put(`/frases/${f.id}`, { texto: f.texto, activa: !f.activa }), f.activa ? 'Frase desactivada' : 'Frase activada')}
                  style={{ background: f.activa ? 'rgba(5,150,105,0.1)' : '#f1f5f8', border: '1px solid #d8e5ec', color: f.activa ? '#047857' : '#6b8295', borderRadius: 4, padding: '3px 9px', cursor: 'pointer', fontSize: 11, fontFamily: 'inherit' }}
                >{f.activa ? 'Activa' : 'Inactiva'}</button>
                <button
                  onClick={() => { setEditId(f.id); setEditTexto(f.texto); }}
                  style={{ background: 'none', border: 'none', color: '#00b8e3', cursor: 'pointer', fontSize: 12, fontFamily: 'inherit' }}
                >Editar</button>
                <button
                  onClick={() => window.confirm('¿Eliminar esta frase?') && correr(() => API.delete(`/frases/${f.id}`), 'Frase eliminada')}
                  style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 15 }}
                  title="Eliminar"
                >×</button>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
